var _path, _path2, _path3, _rect, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _rect2, _rect3, _path14, _path15, _path16, _path17, _rect4, _path18, _path19, _path20, _path21, _path22, _rect5, _path23, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTradingBotLogo3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 142,
    viewBox: "0 0 144 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.02226 38.0537C6.43287 26.685 15.0621 17.7459 19.4821 13.6904C32.4403 4.50176 39.3194 3.51293 47.9964 2.26569L48.167 2.24116C61.6801 0.29828 91.4983 0.477272 103.874 4.14715C119.344 8.73451 128.184 17.9092 133.408 27.4828C138.632 37.0564 144.659 52.2146 140.842 82.531C137.788 106.784 124.97 115.64 114.121 121.623L96.2395 130.798L74.7424 140.372C64.697 136.316 40.7887 126.051 25.5195 117.435C6.43311 106.665 2.81677 87.3178 1.81225 82.531C-0.322345 72.3591 1.42326 50.3108 4.02226 38.0537Z",
    fill: "url(#paint0_linear_1777_10071)",
    stroke: "black",
    strokeWidth: 1.36667
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3128 82.3086H2.6875L3.28809 85.3535L4.08889 88.8045L5.29007 92.4584L6.89166 96.3153C17.6223 96.4777 25.9772 96.2476 27.1117 95.7063C29.1937 92.9456 28.7132 85.0829 28.3128 82.3086Z",
    stroke: "black",
    strokeWidth: 1.13889
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7737 34.7959C33.6859 25.1719 21.2594 18.8013 16.4414 17.2641C29.484 2.52405 45.7761 1.71125 61.7259 0.915526L62.0719 0.898261C75.1182 0.246789 99.2995 1.07579 111.657 6.91334C126.513 13.9308 134.743 26.5623 138.558 38.3917C142.372 50.2212 143.175 70.4716 141.569 80.697C139.667 92.8057 136.158 112.308 119.286 117.188C100.616 122.588 76.9274 120.783 57.0531 116.185C39.4733 112.118 37.5808 92.7444 36.7777 84.5224L36.7774 84.5197C35.9744 76.2992 38.3834 46.8258 35.7737 34.7959Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.36667
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 84.8984,
    y: 94.5312,
    width: 18.9475,
    height: 4.88968,
    rx: 1.48056,
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.16 89.3543C53.5108 82.5632 42.1283 81.876 36.918 82.4823C37.5192 94.205 38.3207 100.066 43.5311 107.343C47.6707 113.123 54.3525 116.034 61.3664 116.842V100.268C61.3664 93.5987 59.162 91.0386 58.16 89.3543Z",
    stroke: "black",
    strokeWidth: 1.36667
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1938 36.7049C27.0041 33.4673 19.1434 29.0938 14.8761 26.9922L10.3281 39.2608C13.4275 39.6698 24.309 45.5656 29.5307 55.1079L31.7205 43.6912C31.6082 42.9528 31.2028 39.6751 29.1938 36.7049Z",
    fill: "#CAA2FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.449 113.834L7.88281 97.2812L9.00614 99.357L10.2899 101.592C11.9978 104.133 14.6099 108.053 18.8784 111.652C22.2941 114.531 25.0379 116.407 31.8693 119.625L40.1242 123.869L60.9053 124.48L84.1313 125.244L103.69 125.855L116.525 119.285L117.901 118.215C102.194 122.479 73.4128 120.78 56.8466 117.731L33.449 113.834Z",
    fill: "#7057F0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4466 126.926H62.0405L71.1445 136.4L49.4466 126.926Z",
    fill: "#383740"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7112 85.3633H6.35547L7.88356 90.09L25.2019 90.253C26.0169 89.2098 26.0508 86.5585 25.7112 85.3633Z",
    fill: "#826CF7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1968 127.539H65.5002L75.1172 137.93L52.1968 127.539Z",
    fill: "#634AE4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4453 124.48L105.373 126.556L98.3595 130.291L95.9549 131.536L94.3518 132.366L74.7144 141.289L65.2965 137.346L55.8785 132.988L38.4453 124.48Z",
    fill: "#7057F0",
    stroke: "black",
    strokeWidth: 0.911111
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4461 127.539H64.6657L73.8945 137.93L49.4461 127.539Z",
    fill: "#644AE7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3635 74.3633H85.5099V81.3922L74.3553 97.5893L53.8798 83.3786L44.2532 81.3922L37.9883 78.1833L39.3635 74.3633Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7429 44.4141H87.0377V35.3505L75.8472 14.4647L55.3058 32.789L45.6483 35.3505L39.3633 39.4882L40.7429 44.4141Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 38.1406,
    y: 46.2461,
    width: 3.66726,
    height: 28.1157,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 87.3398,
    y: 44.4141,
    width: 7.02892,
    height: 28.1157,
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3596 73.5959L41.4993 69.1646L42.1105 71.4567L43.4852 73.1369L45.0133 74.0537L46.5413 74.5121L42.6943 77.172L39.3596 73.5959Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9565 74.3256L88.1699 68.2877L87.496 69.472L87.1904 71.0001L86.3663 72.5281L85.0512 73.5977L83.6759 74.2089L82.4535 74.5145L81.2311 75.3942L86.3663 79.0789L90.9565 74.3256Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M90.551 74.0547H136.697V81.0836L125.543 97.2807L105.067 83.07L95.4407 81.0836L89.1758 77.8748L90.551 74.0547Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9304 44.1055H138.225L133.947 35.0419L119.583 17.9762L106.493 32.4804L96.8358 35.0419L90.5508 39.1796L91.9304 44.1055Z",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 89.3281,
    y: 45.9414,
    width: 3.66726,
    height: 28.1157,
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M90.551 73.2912L92.6907 68.8599L93.3019 71.152L94.6766 72.8322L96.2047 73.7491L97.7327 74.2075L93.8857 76.8673L90.551 73.2912Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M140.212 74.2098L139.357 67.983L138.683 69.1674L138.378 70.6954L137.554 72.2234L136.239 73.293L134.863 73.9042L133.641 74.2098L132.419 75.0895L137.554 78.7742L140.212 74.2098Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4968 44.412H119.428H133.792L136.084 46.5513L137.917 48.9961L138.223 42.2728L133.792 35.3484L118.664 17.0603L102.06 32.787L92.4022 35.3484L86.1172 39.4861L87.4968 44.412Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M90.551 74.3633H136.697V81.3922L125.543 97.5893L105.067 83.3786L95.4407 81.3922L89.1758 78.1833L90.551 74.3633Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M91.078 77.4606L96.6075 74.9087L95.5229 74.2915L94.1235 74.0116L92.7242 73.257L91.7446 72.0526L91.1849 70.7931L90.905 69.6737L90.0994 68.5542L86.7251 73.257L91.078 77.4606Z",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 87.6484,
    y: 45.3281,
    width: 3.66726,
    height: 28.1157,
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M137.461 43.9531L139.295 45.7868L141.128 59.2334V66.7207L140.823 72.2216L139.6 79.4033L132.724 76.5001L132.266 74.8193L134.558 73.7496L137.003 71.916V56.4829V48.9956L137.461 43.9531Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1777_10071)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.3164,
    y: 44.4141,
    width: 45.5352,
    height: 29.9493,
    rx: 3.87222,
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1777_10071)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 114.081,
    cy: 60.1523,
    rx: 19.1003,
    ry: 12.9882,
    fill: "#2DBDFF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1777_10071)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 114.517,
    cy: 59.8221,
    rx: 15.7167,
    ry: 10.5917,
    fill: "#0652FF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M102.447 60.9642H117.384C117.87 60.9642 117.871 60.9642 117.871 60.4756C117.871 60.0971 117.846 59.7157 117.878 59.3393C117.911 58.9629 117.761 58.8897 117.415 58.8912C114.209 58.9032 111.003 58.8983 107.798 58.8983H102.445C102.865 53.2878 107.72 48.2867 114.113 48.3165C120.475 48.3471 125.82 53.596 125.676 60.1929C125.541 66.434 120.448 71.4685 114.197 71.5487C107.752 71.6311 102.852 66.5824 102.447 60.9642Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1777_10071)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41.8047,
    y: 44.4141,
    width: 45.5352,
    height: 29.9493,
    rx: 3.87222,
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_1777_10071)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.573,
    cy: 60.1523,
    rx: 19.1003,
    ry: 12.9882,
    fill: "#2DBDFF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_1777_10071)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 65.4294,
    cy: 59.936,
    rx: 16.0583,
    ry: 10.7056,
    fill: "#0652FF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M53.9311 60.9642H68.8679C69.3542 60.9642 69.3549 60.9642 69.3556 60.4756C69.3556 60.0971 69.3301 59.7157 69.3627 59.3393C69.3954 58.9629 69.2456 58.8897 68.8991 58.8912C65.693 58.9032 62.4875 58.8983 59.282 58.8983H53.9297C54.3493 53.2878 59.2047 48.2867 65.5971 48.3165C71.9597 48.3471 77.3043 53.596 77.1602 60.1929C77.0253 66.434 71.9321 71.4685 65.6809 71.5487C59.2359 71.6311 54.3365 66.5824 53.9311 60.9642Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1777_10071",
    x: 84.1838,
    y: 36.3674,
    width: 59.7926,
    height: 47.5699,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.39833,
    result: "effect1_foregroundBlur_1777_10071"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1777_10071",
    x: 91.4436,
    y: 41.8732,
    width: 46.148,
    height: 35.898,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.67861,
    result: "effect1_foregroundBlur_1777_10071"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1777_10071",
    x: 34.676,
    y: 36.3674,
    width: 59.7926,
    height: 47.5699,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.39833,
    result: "effect1_foregroundBlur_1777_10071"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_1777_10071",
    x: 42.0139,
    y: 41.8732,
    width: 46.8316,
    height: 36.1246,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.67861,
    result: "effect1_foregroundBlur_1777_10071"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1777_10071",
    x1: 15.5245,
    y1: 19.5047,
    x2: 55.0462,
    y2: 140.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C981FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#B589FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491707,
    stopColor: "#AF86FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738033,
    stopColor: "#866FF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#806CF5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1777_10071"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.3125,
    y: 44.4141,
    width: 45.5352,
    height: 29.9493,
    rx: 3.87222,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1777_10071"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41.8047,
    y: 44.4141,
    width: 45.5352,
    height: 29.9493,
    rx: 3.87222,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradingBotLogo3);
export default __webpack_public_path__ + "static/media/TradingBotLogo_3.ba324bde64234aa5d5888cf83c8ccefd.svg";
export { ForwardRef as ReactComponent };